export function removeUndefinedValues(obj: Record<string, unknown>) {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined));
}

export function removeUndefinedAndNullValues(obj: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== undefined && value !== null),
  );
}

export function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isEmptyObject(obj: Record<string, unknown>) {
  return Object.keys(obj).length === 0;
}
